import React from 'react';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-5px); }
`;

const IconWrapper = styled.div`
  filter: drop-shadow(0px 4px 6px rgba(0,0,0,0.3));
  cursor: pointer;
  animation: ${bounce} 2s infinite ease-in-out;
  transition: transform 0.2s;
  
  &:active {
    transform: scale(0.95);
  }
`;

/**
 * 🎁 GiftBoxIcon
 * Simple 2D Vector Icon for Point Spot (Reward Pin)
 */
const GiftBoxIcon = ({ size = 40, onClick, children }) => {
  return (
    <IconWrapper onClick={onClick} style={{ width: size, height: size, position: 'relative' }}>
      <svg width="100%" height="100%" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        {/* Main Box - Red Gradient */}
        <rect x="15" y="35" width="70" height="55" rx="4" fill="url(#boxFixed)" />
        <defs>
          <linearGradient id="boxFixed" x1="50" y1="35" x2="50" y2="90" gradientUnits="userSpaceOnUse">
            <stop stopColor="#FF5252" />
            <stop offset="1" stopColor="#D50000" />
          </linearGradient>
        </defs>

        {/* Lid - Slightly Darker/Wider */}
        <rect x="10" y="25" width="80" height="15" rx="3" fill="#D32F2F" />

        {/* Vertical Ribbon - Gold */}
        <rect x="42" y="35" width="16" height="55" fill="#FFC107" />
        <rect x="42" y="25" width="16" height="15" fill="#FFB300" />

        {/* Bow - Top Ribbon */}
        <path d="M50 28C50 28 30 10 20 20C10 30 42 35 50 28Z" fill="#FFC107" stroke="#FFA000" strokeWidth="1" />
        <path d="M50 28C50 28 70 10 80 20C90 30 58 35 50 28Z" fill="#FFC107" stroke="#FFA000" strokeWidth="1" />

        {/* Center Knot */}
        <circle cx="50" cy="28" r="4" fill="#FFA000" />
      </svg>
      {children}
    </IconWrapper>
  );
};

export default GiftBoxIcon;
